import _includes from 'lodash/includes'
import { URL_MARKETPLACE_LOGGED_IN } from './constants'

/**
 * Wraps a storefront product URL so navigation goes through Gaia `/shop` (multipass/OIDC).
 * Matches `Content.ctaProductUrl` and Spotlight `getPromoButtonLink` for marketplace products.
 *
 * @param {string|null|undefined} storefrontProductUrl Inner URL (e.g. `Content.ctaPath`).
 * @returns {string|null}
 */
export default function marketplaceProductUrlThroughShop (storefrontProductUrl) {
  if (!storefrontProductUrl) {
    return null
  }
  const shopAuthRedirectPath = `${URL_MARKETPLACE_LOGGED_IN}?redirect`
  if (!_includes(storefrontProductUrl, shopAuthRedirectPath)) {
    return `${shopAuthRedirectPath}=${encodeURIComponent(storefrontProductUrl)}`
  }
  return storefrontProductUrl
}
